/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Product/ProductAddToCart',[
    'jquery',
    'global/all',
    'modules/Cart/all',
    'modules/Favorites/FavoritesManager',
    'modules/Delivery/DeliveryOptions',
    'modules/GiftCards/GiftCards',
    'modules/Product/ProductService',
    'modules/Product/ProductOutOfStockService',
    'modules/Product/UnitsOfMeasure',
    './ProductAddToCart.Forms',
    'modules/Upcharges/UpchargeRegistrationService',
    'modules/Upcharges/Upcharges',
    'plugins/accounting.min'
], function ($, Roc, Cart, FavoritesManager, DeliveryOptions, GiftCards, ProductService, ProductOutOfStockService, UnitsOfMeasure, Forms, UpchargeRegistrationService, Upcharges, accounting) {
    'use strict';

    var orderItemId;
    var apiUrl = window.RocConfig.api.baseRocApiUrl;
    var minimumOutOfStockThreshold = 0;
    var qtyDiscounts = [];
    var btns = {
        addToCart: '[data-roc-action="addToCart"]',
        favoritesAddItem: '[data-roc-action="favoritesAddItem"]',
        favoritesAddToCart: '[data-roc-action="favoritesAddToCart"]',
        favoritesCreateList: '[data-roc-action="favoritesCreateList"]',
        addInventoryNotification: '[data-roc-action="addInventoryNotification"]',
        removeInventoryNotification: '[data-roc-action="removeInventoryNotification"]',
        reloadOutOfStock: '[data-roc-action="reloadOutOfStock"]'
    };

    function inventoryWrapper() {
        return $('[data-roc-wrapper="product-inventory"]');
    }

    function giftCardWrapper() {
        return $('[data-roc-wrapper="product-gift-card"]');
    }

    function getProductId() {
        return $('#hdnProductId').val();
    }

    function getGroupId() {
        return $('#hdnGroupId').val() || null;
    }

    function getUomId(productId) {
        //Custom code to support addToCart from listing page 
        var uomSelector = '.selectedUom[data-roc-productId=' + productId + ']';
        return $(uomSelector).val() || null;
    }

    function getOrderItemId() {
        return $('#hdnOrderItemId').val();
    }

    function getValidatedRequestData(srcButton, qtySelector, quickViewAction) {
        var wantsQty = null;
        var isSingleProductMode = false;

        // setting value from main quantity input
        var $qty = $(qtySelector);
        if ($qty.length > 0) {
            wantsQty = $qty.val();
        }

        var dataProductId = $(srcButton).attr('data-product-id');
        var qtyCtrl = $('[data-roc-input="purchaseQuantitySimple"][data-product-id="' + dataProductId + '"]');

        if (qtyCtrl.length > 0) {
            wantsQty = qtyCtrl.val();
            isSingleProductMode = true;
        }

        var qty = (!wantsQty || isNaN(wantsQty)) ? -1 : parseInt(wantsQty);

        if (isNaN(qty) || qty <= 0) {
            throw {
                msg: 'The quantity provided is invalid. Please enter a value greater than 0 and try again.'
            };
        } else {
            var productId = isSingleProductMode ? dataProductId : getProductId();
            if (!productId) {
                var msg = '';
                if (quickViewAction === undefined || quickViewAction !== Roc.Enums.quickViewAction.EDIT) {
                    msg = 'We had trouble adding the item to your cart. ';
                }

                msg += 'Please make sure all options are properly selected before trying again.';

                throw {
                    msg: msg,
                    title: 'Oh no!'
                };
            }

            var request = {
                'productId': productId,
                'quantity': qty,
                'orderId': '{orderId}',
                'groupId': getGroupId(),
                'uomId': getUomId(productId)
            };

            return request;
        }
    }

    function addToCart(event) {
        Roc.Logger.debug('Adding to Cart...');
        var btnAddToCart = event.target;

        try {
            var request = getValidatedRequestData(btnAddToCart, 'input#purchaseQuantity');
            var deliveryOptions = DeliveryOptions.getProductDeliveryOptions(request.productId);
            var giftCartData = null;

            // If used, upchargeData should be:
            // {
            //      <upcharge-code>: {
            //          code: <upcharge-code>,
            //          [amount-modifier: <money>,]
            //          json: <json-string-or-object>,
            //      },
            //      <upcharge-code>: {
            //          code: <upcharge-code>,
            //          [amount-modifier: <money>,]
            //          json: <json-string-or-object>,
            //      },
            //      ...
            // }
            var upchargeData = {};

            // populate upcharge data for any registered upcharges
            UpchargeRegistrationService.populateUpchargeData(upchargeData);


            if ($('[data-roc-wrapper=product-gift-certificate-' + request.productId + ']').length > 0) {
                var isValid = Roc.Validation.validateForm(GiftCards.forms.CertificateDetails);
                if (isValid) {
                    giftCartData = Roc.Validation.getFieldValues(GiftCards.forms.CertificateDetails);
                } else {
                    return;
                }
            }
            /* check if cart is not locked before action */
            Cart.CartLocker.isCartUnlocked()
                .then(function () {
                    Roc.Core.lockButton(btnAddToCart);
                    Cart.CartManager.addCartItem(
                        request.productId,
                        request.quantity,
                        request.groupId,
                        request.uomId,
                        getOrderItemId(),
                        deliveryOptions,
                        giftCartData,
                        upchargeData);
                });



        } catch (error) {
            Roc.Logger.debug('Error adding to cart');
            Roc.Logger.debug(error);

            if (event && ($(event.currentTarget).closest('.mfp-container').length !== 0)) {
                Roc.UI.template('errorBox-Tmp', error).then(function (renderedTemplate) {
                    var modalInstance = $.magnificPopup.instance;

                    $(modalInstance.content).find('.modal-body').prepend(renderedTemplate);
                });
            } else {
                Roc.UI.displayErrorPopup(error.msg, error.title);
            };
        }
        return;
    }

    function itemAddedToCartEvt(data) {
        Roc.Core.releaseLockedButton(btns.addToCart);

        if (!data.success) {
            var model = data || {};

            model.templ = 'addToCart';
            model.heading = data.message || 'An error occurred while trying to add the item to your cart.';

            Roc.UI.template('serviceErrors-Tmp', model).then(function (renderedTemplate) {
                Roc.UI.displayErrorPopup(renderedTemplate);
            });

            return;
        }
    }

    function addToCartEvt() {
        Roc.UI.siteBody
            .off('click', btns.addToCart)
            .on('click', btns.addToCart, function (e) {
                e.preventDefault();
                addToCart(e);
            });

        Roc.UI.siteBody
            .off('keypress', 'input#purchaseQuantity')
            .on('keypress', 'input#purchaseQuantity', function (e) {
                if (e.which === 13) {
                    e.preventDefault();
                    $(btns.addToCart).trigger('click');
                };
            });
    }

    function addToFavoritesEvt() {

        Roc.UI.siteBody
            .off('click', btns.favoritesAddItem)
            .on('click', btns.favoritesAddItem, function () {
                var upchargeData = {};
                // populate upcharge data for any registered upcharges
                UpchargeRegistrationService.populateUpchargeData(upchargeData);

                var listId = $(this).attr('data-listid');
                var productId = getProductId(); // get product id for current selections (if applicable)

                if (!productId) {
                    productId = $(this).attr('data-product-id');
                }

                FavoritesManager.addItem(productId, listId, 1, getGroupId(), getUomId(productId), upchargeData);
                Roc.UI.block();
            });
    }

    function addToFavoritesWithRedirectEvt() {
        Roc.UI.siteBody
            .off('click', btns.favoritesAddToCart)
            .on('click', btns.favoritesAddToCart, function () {
                var redirectUrl = $(this).attr('data-redirect-url');
                var uomId = getUomId();
                if (uomId) {
                    redirectUrl += "&uomId=" + encodeURIComponent(uomId);
                }
                window.location.href = redirectUrl;
            });
    }

    function createFavoritesListAndAddItemEvt() {
        Roc.UI.siteBody
            .off('click', btns.favoritesCreateList)
            .on('click', btns.favoritesCreateList, function () {
                var productId = getProductId();
                FavoritesManager.addListAndMoveItem(productId, getUomId(productId));
            });
    }

    function favoritesListAdded(data) {
        if (data.Result === true && data.id) {
            $('.roc-addToCartFavoritesMenu ul').each(function () {
                $(this).prepend('<li><button class="btn btnText" data-roc-action="favoritesAddItem" data-listid="' + data.id + '">' + data.name + '</button></li>');
            });
        }
    }

    function itemFavorited(data) {
        Roc.UI.unblock();
    }

    function reloadOutOfStockTempl(data) {
        Roc.UI.template('productInventoryActionOutOfStock-Tmp', data).then(function (renderedTemplate) {
            inventoryWrapper().html(renderedTemplate);
        });
    }

    function addInventoryNotificationEvt() {
        $(document)
            .off('click', btns.addInventoryNotification)
            .on('click', btns.addInventoryNotification, function () {

                if (!Roc.Validation.validateForm(Forms.addInventoryNotificationForm, true, false)) {
                    return false;
                }

                // validate if someone is submitting inventory notification for group product
                var productId = getProductId();
                if (!productId) {
                    var msg = 'Please make a selection to be notified when product comes back in stock.';
                    Roc.UI.displayErrorPopup(msg, 'Oh no!');
                    return false;
                }

                var data = Roc.Forms.getFormValues(Forms.addInventoryNotificationForm);
                data.productId = $(this).attr('data-product-id');

                if (!data.productId || !data.email) {
                    return false; // exit here to reduce nesting
                }

                Roc.UI.block();
                Roc.Core.lockButton(btns.addInventoryNotification);

                ProductOutOfStockService.addInventoryNotification(data).then(function (result) {
                    data.tmpl = 'addInventoryNotificationSuccess';
                    reloadOutOfStockTempl(data);
                }, function (xhr) {
                    if (xhr.responseJSON && xhr.responseJSON.additionalErrorDetails && xhr.responseJSON.additionalErrorDetails.alreadySubmitted) {
                        data.tmpl = 'emailAlreadySubmitted';
                        reloadOutOfStockTempl(data);
                    }
                    else {
                        Roc.UI.displayExceptionPopup(xhr);
                    }
                }).always(function (result) {
                    Roc.Core.releaseLockedButton(btns.addInventoryNotification);
                    Roc.UI.unblock();
                });
            });
    }

    function removeInventoryNotificationEvt() {
        $(document)
            .off('click', btns.removeInventoryNotification)
            .on('click', btns.removeInventoryNotification, function () {
                var data = {
                    email: $(this).attr('data-email'),
                    productId: $(this).attr('data-product-id')
                };

                ProductOutOfStockService.removeInventoryNotification(data).then(function () {
                    data.tmpl = 'removeInventoryNotification';
                    reloadOutOfStockTempl(data);
                }, function (err) {
                    Roc.UI.displayExceptionPopup(err);
                });

                return false;
            });
    }

    function reloadOutOfStockEvt() {
        $(document).on('click', btns.reloadOutOfStock, function () {
            var data = {
                email: $(this).attr('data-email'),
                productId: $(this).attr('data-product-id')
            };
            reloadOutOfStockTempl(data);
            return false;
        });
    }

    function updateInventoryWrapper(productId, htmlContent) {
        inventoryWrapper(productId).html(htmlContent);
    }

    function updateAddToCartBtnVisibility(show) {
        var qtySel = '[data-roc-wrapper="product-quantity"]';
        if (show) {
            $(qtySel).show();
            $(btns.addToCart).show();
        } else {
            $(qtySel).hide();
            $(btns.addToCart).hide();
        }
    }
    function reloadInventoryAction(viewModel) {
        // if MS2/ISP is turned on then inventory information is displayed next to each option
        if (DeliveryOptions.isAnyDeliveryOptionAvailable()) {
            return;
        }

        var html = '';
        // get email address that could have been provided for out of stock email notification
        // don't force user to provide it again when making selections
        var outOfStockNotificationEmail = ProductOutOfStockService.getCurrentEmailAddress();

        switch (viewModel.productType) {
            case Roc.Enums.productType.Group:
                if (viewModel.inventoryStatus && viewModel.inventoryStatus !== 'Backorder') {
                    var outOfStockViewModel = {
                        'productId': viewModel.id,
                        'outOfStockNotificationEmail': outOfStockNotificationEmail
                    };
                    Roc.UI.template('productInventoryActionOutOfStock-Tmp', outOfStockViewModel).then(function (renderedTemplate) {
                        html = renderedTemplate;
                        updateInventoryWrapper(viewModel.productId, renderedTemplate);
                    });
                } else {
                    updateInventoryWrapper(viewModel.productId, html); // clear inventory action wrapper
                }
                break;
            default:
                var itemsIn1Uom = getNumberOfItemsInSelectedUom(viewModel);
                if (viewModel.fulfillmentInventory && viewModel.fulfillmentInventory.qtyAvailable <= minimumOutOfStockThreshold * itemsIn1Uom) {
                    viewModel.filfillmentInventory.outOfStockNotificationEmail = outOfStockNotificationEmail;

                    Roc.UI.template('productInventoryAction-Tmp', viewModel.fulfillmentInventory).then(function (renderedTemplate) {
                        html = renderedTemplate;
                        updateInventoryWrapper(viewModel.productId, renderedTemplate);
                    });
                } else {
                    updateInventoryWrapper(viewModel.productId, html); // clear inventory action wrapper
                }
                break;
        }

        var displayAddToCartBtn = ProductService.addToCartButtonDisplay(viewModel);
        updateAddToCartBtnVisibility(displayAddToCartBtn);
    }

    function getNumberOfItemsInSelectedUom(product) {
        var uomInfo = UnitsOfMeasure.getUnitsOfMeasureInfoForProduct(product);
        if (uomInfo && uomInfo.selectedUomId && uomInfo.unitsOfMeasure) {
            var uom = _.find(uomInfo.unitsOfMeasure, function (unit) {
                return unit.id === uomInfo.selectedUomId;
            });
            if (uom) {
                return uom.quantityInBaseUnit;
            }
        }
        return 1;
    }

    function reloadGiftCardForm(viewModel) {
        if (viewModel.productType === Roc.Enums.productType.GiftCard && viewModel.isVirtualItem) {
            Roc.UI.template('giftCardForm-Tmp', { productId: viewModel.id }).then(function (renderedTemplate) {
                giftCardWrapper().html(renderedTemplate);
            });
        } else {
            giftCardWrapper().html('');
        }
    }

    function populateGiftCardForm(currentItem) {
        if (currentItem && currentItem.isCertificate && currentItem.isVirtualItem) {
            Roc.UI.template('giftCardForm-Tmp',
                {
                    productId: currentItem.productId,
                    certificateFromName: currentItem.certificateFromName,
                    certificateToName: currentItem.certificateToName,
                    certificateToEmail: currentItem.certificateToEmail,
                    certificateMessage: currentItem.certificateMessage
                })
                .then(function (renderedTemplate) {
                    giftCardWrapper().html(renderedTemplate);
                });
        }
    }

    function updateOrderCartItemDetails(currentCart) {
        if (!currentCart) {
            return;
        }
        var currentItem = _.find(currentCart.items, { 'id': orderItemId });
        populateGiftCardForm(currentItem);
    }

    function handleEnterKeyPressEvt() {
        Roc.Core.handleEnter('#txtEmailMe', function (e) {
            e.preventDefault();
            $(btns.addInventoryNotification).trigger('click');
            return false;
        });
    }

    function bindQuantityDiscountsEventsKeyUp() {
        Roc.UI.siteBody
            .off('keyup', '#purchaseQuantity')
            .on('keyup', '#purchaseQuantity', function (e) {
                updatePrice();
            });
    }

    function bindQuantityDiscountsEvents() {
        Roc.UI.siteBody
            .off('change', '#purchaseQuantity')
            .on('change', '#purchaseQuantity', function (e) {
                updatePrice();
            });
    }
    function updatePrice() {
        if (qtyDiscounts) {
            var price;
            var currentQty = parseInt($('#purchaseQuantity').val());
            {
                var applicableDiscount = qtyDiscounts.find(function (discount) {
                    return discount.minQty <= currentQty && discount.maxQty >= currentQty && discount.price > 0;
                });

                if (applicableDiscount) {
                    price = applicableDiscount.price;
                } else {
                    var maxDiscount = qtyDiscounts.filter(function (discount) {
                        return discount.price > 0;
                    }).sort(function (a, b) {
                        return b.maxQty - a.maxQty;
                    }).find(function () {
                        return true; // Find the first element after sorting
                    });

                    if (maxDiscount) {
                        price = maxDiscount.price;
                    }
                }
                if (price) {
                    $('[data-roc-binding="pricing"] [itemprop="price"]').html("$" + (Math.round(price * 100) / 100).toFixed(2));
                    var totalPrice = price * currentQty;
                    $("#totalPrice").html("<span>Total Price: " + accounting.formatMoney(totalPrice) + "</span><br />");
                }
            }
        }
    }

        function bindEvents() {
            if (bindEvents.COMPLETED) {
                return;
            }

            addToCartEvt();
            addToFavoritesEvt();
            createFavoritesListAndAddItemEvt();
            addToFavoritesWithRedirectEvt();
            addInventoryNotificationEvt();
            removeInventoryNotificationEvt();
            reloadOutOfStockEvt();
            handleEnterKeyPressEvt();

            UpchargeRegistrationService.bindUpchargeEvents();

            Roc.EventManager.bind(Roc.Events.cart.ADD_ITEM, itemAddedToCartEvt);
            Roc.EventManager.bind(Roc.Events.favorites.ADD_LIST, favoritesListAdded);
            Roc.EventManager.bind(Roc.Events.favorites.ADD_ITEM, itemFavorited);
            Roc.EventManager.bind(Roc.Events.products.SELECTIONS_UPDATE, reloadInventoryAction);
            Roc.EventManager.bind(Roc.Events.products.SELECTIONS_UPDATE, reloadGiftCardForm);
            orderItemId = Roc.UrlHelper.getQueryStringParameterByName('orderItemId');
            if (orderItemId) {
                Roc.EventManager.bind(Roc.Events.cart.GET_CURRENT_CART, updateOrderCartItemDetails);
                Cart.CartManager.getCurrentCart();
            }
            bindEvents.COMPLETED = true;
        }

        function init(minOutOfStockThreshold, quantityDiscounts) {
            if (minOutOfStockThreshold !== undefined) {
                minimumOutOfStockThreshold = minOutOfStockThreshold;
            }
            if (quantityDiscounts) {
                qtyDiscounts = quantityDiscounts;
            }
            bindEvents();
            bindQuantityDiscountsEvents();
            bindQuantityDiscountsEventsKeyUp();
            DeliveryOptions.setAddToCartButtonVisibilityCallback(updateAddToCartBtnVisibility);

            UpchargeRegistrationService.initForAddToCart();
        };

        function initForQuickView() {
            addToCartEvt();
            addInventoryNotificationEvt();
            removeInventoryNotificationEvt();
            reloadOutOfStockEvt();
            Roc.EventManager.bind(Roc.Events.cart.ADD_ITEM, itemAddedToCartEvt);
        }

        var ProductAddToCart = {
            init: init,
            initForQuickView: initForQuickView,
            getValidatedRequestData: getValidatedRequestData
        };

        Roc.Logger.debug('ProductAddToCart.js Loaded:', ProductAddToCart);

        return ProductAddToCart;
    });
